import { useState } from 'react';
import { FormGroup } from '../../components/molecules/FormGroup/FormGroup';
import { formatPhoneInput, isPhoneComplete, isEmailValid } from '../../lib/validators';
import styles from './Inquiry.module.css';

const LEGAL_ISSUE_OPTIONS = [
  { value: '', label: '해당 사항 선택' },
  { value: 'PATIENT_CLAIM', label: '환자 클레임·의료분쟁' },
  { value: 'MEDICAL_ACCIDENT', label: '의료사고' },
  { value: 'LABOR', label: '직원 인사노무' },
  { value: 'REGULATORY', label: '보건소·행정 조사' },
  { value: 'REAL_ESTATE', label: '병원 임대차·부동산' },
  { value: 'OTHER', label: '기타 법률 문제' },
  { value: 'PREVENTIVE', label: '현재 문제 없음 (예방 목적)' },
];

export function AdvisoryForm({ onSubmit, defaultEmail = '', isSubmitting = false }) {
  const [form, setForm] = useState({
    applicantName: '',
    phone: '',
    clinicName: '',
    email: defaultEmail,
    legalIssueType: '',
    message: '',
  });

  const [touched, setTouched] = useState({ phone: false, email: false });

  const update = (field) => (e) => setForm((prev) => ({ ...prev, [field]: e.target.value }));
  const updatePhone = (e) =>
    setForm((prev) => ({ ...prev, phone: formatPhoneInput(e.target.value) }));
  const markTouched = (field) => () => setTouched((prev) => ({ ...prev, [field]: true }));

  const phoneError = touched.phone && form.phone && !isPhoneComplete(form.phone);
  const emailError = touched.email && form.email && !isEmailValid(form.email);
  const canSubmit =
    !isSubmitting &&
    form.applicantName.trim() &&
    isPhoneComplete(form.phone) &&
    form.clinicName.trim() &&
    isEmailValid(form.email);

  const handleSubmit = () => {
    if (!canSubmit) return;
    onSubmit({
      inquiryType: 'ADVISORY',
      applicantName: form.applicantName.trim(),
      phone: form.phone.trim(),
      email: form.email.trim() || undefined,
      message: form.message.trim() || undefined,
      advisory: {
        clinicName: form.clinicName.trim(),
        legalIssueType: form.legalIssueType || undefined,
      },
    });
  };

  return (
    <div>
      <div className={styles.fRow}>
        <FormGroup label="신청자 성함" required>
          <input
            type="text"
            className={styles.fInput}
            placeholder="홍길동"
            value={form.applicantName}
            onChange={update('applicantName')}
          />
        </FormGroup>
        <FormGroup label="연락처" required>
          <input
            type="tel"
            inputMode="numeric"
            className={styles.fInput}
            placeholder="010-0000-0000"
            value={form.phone}
            onChange={updatePhone}
            onBlur={markTouched('phone')}
            maxLength={13}
          />
          {phoneError && (
            <p className={styles.fHint}>
              전화번호 형식이 올바르지 않습니다. (예: 010-1234-5678, 02-123-4567)
            </p>
          )}
        </FormGroup>
      </div>
      <FormGroup label="의원명" required>
        <input
          type="text"
          className={styles.fInput}
          placeholder="○○의원"
          value={form.clinicName}
          onChange={update('clinicName')}
        />
      </FormGroup>
      <FormGroup label="이메일">
        <input
          type="email"
          className={styles.fInput}
          placeholder="example@clinic.com"
          value={form.email}
          onChange={update('email')}
          onBlur={markTouched('email')}
        />
        {emailError && <p className={styles.fHint}>올바른 이메일 형식이 아닙니다.</p>}
      </FormGroup>
      <FormGroup label="현재 겪고 계신 법률 문제">
        <select
          className={styles.fSelect}
          value={form.legalIssueType}
          onChange={update('legalIssueType')}
        >
          {LEGAL_ISSUE_OPTIONS.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      </FormGroup>
      <FormGroup label="문의사항">
        <textarea
          className={styles.fTextarea}
          placeholder="궁금하신 점이나 현재 상황을 간략히 기재해 주세요."
          value={form.message}
          onChange={update('message')}
        />
      </FormGroup>
      <button
        type="button"
        className={`${styles.fSubmit} ${styles.btnInk}`}
        onClick={handleSubmit}
        disabled={!canSubmit}
      >
        {isSubmitting ? '제출 중...' : '신청서 제출하기'}
      </button>
      <p className={styles.fNotice}>
        제출하신 정보는 상담 목적으로만 활용되며, 외부에 제공되지 않습니다.
      </p>
    </div>
  );
}
